import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getGoalsQueryKey } from "modules/campaigns/lib/goals/goalsQuery"
import { CreateGoalSchema, GoalResponseDataSchema } from "schema"
import { z } from "zod"

export const useCreateGoalMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payload: z.infer<typeof CreateGoalSchema>) => {
      const { data } = await axios.post<{ data: z.infer<typeof GoalResponseDataSchema> }>(
        "/goals",
        payload,
      )

      queryClient.setQueryData(getGoalsQueryKey({}), () => {
        return data.data
      })

      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === "goals",
      })
    },
  })
}
